import React, { useEffect, useState } from 'react';
import { FaPen, FaPlus } from 'react-icons/fa';
import LoadingState from '../components/LoadingState';
import { useNavigate } from 'react-router-dom';
import { qa } from '../api/api';

const ScorecardList = () => {
  const navigate = useNavigate();
  const [scorecards, setScorecards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadScorecards = async () => {
      try {
        const res = await qa();
        if (Array.isArray(res?.templates)) {
          // Live GET /templates shape: { templates: [{ templateName, language }], count }
          setScorecards(
            res.templates
              .filter(t => t?.templateName)
              .map(t => ({ name: t.templateName, campaign: t.campaign || '' }))
          );
        } else {
          // Defensive fallback for the legacy raw-DynamoDB shape
          const items = res.Items || res.items || [];
          const grouped = {};
          items.forEach(item => {
            const name = item.template?.S || item.scorecard?.S;
            if (!name) return;
            const campaign = item.PK?.S || item.PK || item.campaign?.S || '';
            if (!grouped[name]) grouped[name] = campaign;
          });
          const arr = Object.keys(grouped).map(n => ({ name: n, campaign: grouped[n] }));
          setScorecards(arr);
        }
      } catch (err) {
        console.error('Failed to load scorecards:', err);
      } finally {
        setLoading(false);
      }
    };
    loadScorecards();
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Scorecards</h1>
          <p className="text-gray-600 mt-1">All QA scorecards</p>
        </div>
        <button
          onClick={() => navigate('/scorecards?new=1')}
          className="btn-outline"
        >
          <FaPlus />
          New Scorecard
        </button>
      </div>
      <div className="card">
        {loading ? (
          <LoadingState variant="rows" header={false} label="Loading scorecards" />
        ) : scorecards.length === 0 ? (
          <p className="text-center text-gray-500">No scorecards found.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead>
                <tr className="border-b border-gray-200">
                  <th className="px-5 py-2.5 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wider bg-[#fafafc]">Name</th>
                  <th className="px-5 py-2.5 text-left text-[11px] font-semibold text-gray-500 uppercase tracking-wider bg-[#fafafc]">Campaign</th>
                  <th className="px-5 py-2.5 bg-[#fafafc]" />
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                {scorecards.map(sc => (
                  <tr key={sc.name} className="hover:bg-cloudza-50/40 transition-colors">
                    <td className="px-5 py-3 whitespace-nowrap text-sm font-medium text-gray-900">{sc.name}</td>
                    <td className="px-5 py-3 whitespace-nowrap text-sm text-gray-500">{sc.campaign || '—'}</td>
                    <td className="px-5 py-3 whitespace-nowrap text-sm text-right">
                      <button
                        onClick={() => navigate(`/scorecards?name=${encodeURIComponent(sc.name)}`)}
                        className="btn-outline"
                      >
                        <FaPen />
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScorecardList;
